/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
// @ts-expect-error no typings
import { ObjectTypeId } from 'customer-data-objects-ui-components/propTypes/CrmObjectTypes';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { COMPANY_TYPE_ID, CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import openCallingWidget from 'calling-global-api/methods/openCallingWidget';
import { translateObjectName } from 'customer-data-objects/record/translateObjectName';
import { View } from 'foundations-components/components/View';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function openWidgetAndAddPhoneNumber(subjectId, objectTypeId) {
  openCallingWidget({
    toSubject: {
      objectId: subjectId,
      objectTypeId
    },
    addPhoneNumber: true
  });
}
function AddNumberLink({
  onClick,
  subjectId,
  objectTypeId,
  isThirdPartyCallingPopoverInUse
}) {
  const openPropertiesPanel = useSendCrmMessageTopic(TOPIC_NAMES.OPEN_ALL_PROPERTIES_PANEL);
  const handleClick = useCallback(() => {
    if (isThirdPartyCallingPopoverInUse) {
      openPropertiesPanel({
        objectTypeId,
        objectId: String(subjectId),
        initialSearchTerm: 'phone'
      });
    } else {
      openWidgetAndAddPhoneNumber(subjectId, objectTypeId);
    }
    onClick();
  }, [objectTypeId, onClick, subjectId, isThirdPartyCallingPopoverInUse, openPropertiesPanel]);
  return /*#__PURE__*/_jsx(Button, {
    use: "link",
    onClick: handleClick,
    "data-selenium-test": "no-callees-add-phone-number",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "callee-selection.noCallees.addPhoneNumber"
    })
  });
}
function NoCalleesPrompt({
  objectTypeId,
  subjectId,
  onAddNumberClick = () => {},
  shouldShowAddNumber,
  isThirdPartyCallingPopoverInUse
}) {
  let message = null;
  if (objectTypeId === CONTACT_TYPE_ID) {
    message = /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "callee-selection.noCallees.headings.contactHasNoPhoneNumber"
          })
        })
      }), shouldShowAddNumber && /*#__PURE__*/_jsx(AddNumberLink, {
        onClick: onAddNumberClick,
        subjectId: subjectId,
        objectTypeId: objectTypeId,
        isThirdPartyCallingPopoverInUse: isThirdPartyCallingPopoverInUse
      })]
    });
  } else if (objectTypeId === COMPANY_TYPE_ID) {
    message = /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "callee-selection.noCallees.headings.companyHasNoPhoneNumber"
          })
        })
      }), /*#__PURE__*/_jsx(AddNumberLink, {
        onClick: onAddNumberClick,
        subjectId: subjectId,
        objectTypeId: objectTypeId,
        isThirdPartyCallingPopoverInUse: isThirdPartyCallingPopoverInUse
      })]
    });
  } else {
    message = /*#__PURE__*/_jsx("strong", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "callee-selection.noCallees.headings.noAssociatedRecords",
        options: {
          objectType: translateObjectName(objectTypeId)
        }
      })
    });
  }
  return /*#__PURE__*/_jsx(View, {
    padding: "400",
    as: "div",
    children: message
  });
}
NoCalleesPrompt.propTypes = {
  objectTypeId: ObjectTypeId.isRequired,
  onAddNumberClick: PropTypes.func.isRequired
};
export default /*#__PURE__*/memo(NoCalleesPrompt);